import type { ExportName } from "../type";
import type { ActionType } from "typesafe-actions";
import { createReducer } from "typesafe-actions";
import { managementActions } from "../action-creators";

export type ManageIntegrationModalType = {
    togglesModal: {
        toggleName: ExportName | null;
        isOpen: boolean;
        isDisabled: boolean;
    };
    isMissingMandatoryFieldsModalOpen: boolean;
};

const ManageIntegrationModalState = {
    togglesModal: {
        toggleName: null,
        isOpen: false,
        isDisabled: false,
    },
    isMissingMandatoryFieldsModalOpen: false,
};

export const manageIntegrationModalReducer = createReducer<
    ManageIntegrationModalType,
    ActionType<typeof managementActions.manageIntegrationModal>
>(ManageIntegrationModalState)
    .handleAction(managementActions.manageIntegrationModal.setIntegrationModalState, (state, { payload }) => ({
        ...state,
        togglesModal: {
            ...state.togglesModal,
            isOpen: payload,
        },
    }))
    .handleAction(managementActions.manageIntegrationModal.setToggle, (state, { payload }) => ({
        ...state,
        togglesModal: {
            ...state.togglesModal,
            toggleName: payload,
        },
    }))
    .handleAction(managementActions.manageIntegrationModal.setIsDisabledIntegrationModal, (state, { payload }) => ({
        ...state,
        togglesModal: {
            ...state.togglesModal,
            isDisabled: payload,
        },
    }))
    .handleAction(
        managementActions.manageIntegrationModal.setIsMissingMandatoryFieldsModalOpen,
        (state, { payload }) => ({
            ...state,
            isMissingMandatoryFieldsModalOpen: payload,
        }),
    );
